function ArabicToEthiopic(number) {
	var numberString = number.toString();
	var numberLength = numberString.length - 1

	if ((numberLength % 2) == 0) {
		numberString = "0" + numberString;
		numberLength++;
	}

	var ethioNumberString = "";

	for (var place = numberLength; place >= 0; place--) {
		var asciiOne, asciiTen, ethioOne = null, ethioTen = null;

		asciiTen = numberString.charAt(numberLength - place);
		place--;
		asciiOne = numberString.charAt(numberLength - place);

		if (asciiOne != "0") {
			ethioOne = String.fromCharCode("፩".charCodeAt(0) + (asciiOne.charCodeAt(0) - "1".charCodeAt(0)));
		}

		if (asciiTen != "0") {
			ethioTen = String.fromCharCode("፲".charCodeAt(0) + (asciiTen.charCodeAt(0) - "1".charCodeAt(0)));
		}

		var pos = (place % 4) / 2;

		var sep = null;
		if (place != 0) {
			if (pos == 0) {
				sep = "፼";
			}
			else if ((ethioOne != null) || (ethioTen != null)) {
				sep = "፻";
			}
		}

		if ((ethioOne == "፩") && !(ethioTen) && (numberLength > 1)) {
			if ((sep == "፻") || ((place + 1) == numberLength)) {
				ethioOne = null;
			}
		}

		if (ethioTen) { ethioNumberString += ethioTen; }
		if (ethioOne) { ethioNumberString += ethioOne; }
		if (sep) { ethioNumberString += sep; }

	}

	return ethioNumberString;
}

export default ArabicToEthiopic